import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";

import MatchesCount from "components/MatchesCount";
import useStyles from "./styles";

interface IProps {
  shouldDisplayUnreadCount: boolean;
  unreadCount?: number;
  title: string;
  hasComments: boolean;
  onMarkAllRead?: () => void;
  headerClassName?: string;
}

const CommentsHeader = (props: IProps) => {
  const {
    shouldDisplayUnreadCount,
    title,
    hasComments,
    unreadCount,
    onMarkAllRead,
    headerClassName
  } = props;
  const classes = useStyles();

  const handleMarkAllAsRead = () => {
    onMarkAllRead && onMarkAllRead();
  };

  return (
    <header className={classes.header}>
      <div>
        <span className={clsx(classes.headerTitle, headerClassName)}>
          {!hasComments && <>No&nbsp;</>}
          {title}
        </span>
        {shouldDisplayUnreadCount && Boolean(unreadCount) && (
          <MatchesCount
            className={classes.matchesCount}
            matchedHorsesCount={unreadCount}
          />
        )}
      </div>
      {shouldDisplayUnreadCount && (
        <Button
          className={classes.markAll}
          onClick={handleMarkAllAsRead}
          disabled={!unreadCount}
        >
          Mark All Read
        </Button>
      )}
    </header>
  );
};

export default CommentsHeader;
